module.exports = __webpack_public_path__ + "fonts/NunitoSans-Bold.3bc2c38.woff";